import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/service/api.service';
import { environment } from '../../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CabsProfileService {
  constructor(private apiService: ApiService) { }

  getCABsProfileInfo(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab_baisc_info`, model)
      .pipe(catchError(this.handleError));
  }

  editCabsMainInfo(model, img) {
    const formData = new FormData();
    formData.append('cab_name_en', model.cab_name_en);
    formData.append('cab_name_ar', model.cab_name_ar);
    formData.append('cab_address', model.cab_address);
    formData.append('cab_reigon', model.cab_reigon);
    formData.append('cab_city', model.cab_city);
    formData.append('country_token', model.country_token);
    formData.append('cab_po_box', model.cab_po_box);
    formData.append('cab_phone', model.cab_phone);
    formData.append('phone_token', model.phone_token);
    formData.append('fax_token', model.fax_token);
    formData.append('cab_fax', model.cab_fax);
    formData.append('cab_email', model.cab_email);
    formData.append('cab_second_email', model.cab_second_email);
    formData.append('cab_website', model.cab_website);
    formData.append('user_token', model.user_token);

    formData.append('cab_type', model.cab_type);
    formData.append('cab_tax_number', model.cab_tax_number);
    formData.append('cab_passport_number', model.cab_passport_number);
    formData.append('lat', model.lat);
    formData.append('lang', model.lang);
    formData.append('tradeLicenseNo', model.tradeLicenseNo);
    formData.append('dateOdEstablishment', model.dateOdEstablishment);
    formData.append('members_of_board', model.members_of_board);
    formData.append('cab_mailing_address', model.cab_mailing_address);

    if (img?.name) {
      formData.append('cab_logo', img, img?.name);
    }
    if (model?.cab_passport_photo && model?.cab_passport_photo?.length) {
      model?.cab_passport_photo.forEach(file => {
        formData.append('cab_passport_photo', file, file?.name);
      });
    }

    if (model?.license_file && model?.license_file?.length) {
      model?.license_file.forEach(file => {
        formData.append('license_file', file, file?.name);
      });
    }

    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_baisc_info`, formData)
      .pipe(catchError(this.handleError));
  }
  getContactPersons(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_cab_contact_info`, model)
      .pipe(catchError(this.handleError));
  }
  getListOfTitles() {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_titles`)
      .pipe(catchError(this.handleError));
  }
  createContactPerson(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_contact_info`, model)
      .pipe(catchError(this.handleError));
  }
  editContactPerson(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_contact_info`, model)
      .pipe(catchError(this.handleError));
  }
  deleteContactPerson(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_contact_info`, model)
      .pipe(catchError(this.handleError));
  }
  getListInvoiceAddress(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_cab_invoice_address`, model)
      .pipe(catchError(this.handleError));
  }
  addInvoiceAddress(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_new_invoices`, model)
      .pipe(catchError(this.handleError));
  }
  editInvoiceAddress(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_invoices`, model)
      .pipe(catchError(this.handleError));
  }
  getListAccreditedIn(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_all_my_accredited_in`, model)
      .pipe(catchError(this.handleError));
  }
  loadMoreAccreditedIn(model) {
    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/list_all_my_accredited_in_load_more`,
        model
      )
      .pipe(catchError(this.handleError));
  }

  changeAccreditedInStatus(model, status) {
    let endPoint = null
    if (status == 1) {
      endPoint = 'change_scope_to_active'
    } else if (status == 2) {
      endPoint = 'change_scope_to_suspend'
    } else if (status == 3) {
      endPoint = 'change_scope_to_withdrawn'
    }

    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/` + endPoint,
        model
      )
      .pipe(catchError(this.handleError));
  }

  changeAccreditedInStatusForAllScopes(model) {

    return this.apiService
      .post(
        `${environment.apiUrl}/api/system/` + model.api_link,
        model
      )
      .pipe(catchError(this.handleError));
  }

  cancelChanges(modal, tabName) {
    let apiAction;
    switch (tabName) {
      case 'invoices':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_decline_user_changes_invoices`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;

      case 'contact':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_decline_user_changes_contact`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;

      case 'baisc_info':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_decline_user_changes_baisc`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;

      case 'ownership':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_decline_user_changes_ownership`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      case 'memberOfBoard':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_decline_user_changes_members_of_board`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      case 'workingTime':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_decline_user_changes_working_time`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      case 'personnelInformation':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_decline_user_changes_personnel_information`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      case 'existingAccCer':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_decline_user_changes_existing_accreditation`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      default:
        break;
    }

    return apiAction;
  }

  approveChanges(modal, tabName) {
    let apiAction;
    switch (tabName) {
      case 'invoices':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_approve_user_changes_invoices`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;

      case 'contact':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_approve_user_changes_contact`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;

      case 'baisc_info':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_approve_user_changes_baisc`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;

      case 'ownership':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_approve_user_changes_ownership`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      case 'memberOfBoard':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_approve_user_changes_members_of_board`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      case 'workingTime':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_approve_user_changes_working_time`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
        break;
      case 'personnelInformation':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_approve_user_changes_personnel_information`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      case 'existingAccCer':
        apiAction = this.apiService
          .post(
            `${environment.apiUrl}/api/system/admin_approve_user_changes_existing_accreditation`,
            modal
          )
          .pipe(catchError(this.handleError));
        break;
      default:
        break;
    }


    return apiAction;
  }

  getCabsUsers(modal) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/search_cab_admin`, modal)
      .pipe(catchError(this.handleError));
  }

  assignCabUser(modal) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/change_cab_admin_to_profile`, modal)
      .pipe(catchError(this.handleError));
  }

  getCabsRepresentatives(modal) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/search_cab_representative`, modal)
      .pipe(catchError(this.handleError));
  }

  assignCabRepresentatives(modal) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/assign_user_to_profile`, modal)
      .pipe(catchError(this.handleError));
  }

  confirmVisit(modal, endPoint) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab/` + endPoint, modal)
      .pipe(catchError(this.handleError));
  }

  addOwnership(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_ownership_info`, model)
      .pipe(catchError(this.handleError));
  }
  editOwnership(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_ownership_info`, model)
      .pipe(catchError(this.handleError));
  }
  deleteOwnership(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_ownership_info`, model)
      .pipe(catchError(this.handleError));
  }
  getListOwnership(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_cab_ownership_info`, model)
      .pipe(catchError(this.handleError));
  }

  addMemberOfBoard(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_members_of_board`, model)
      .pipe(catchError(this.handleError));
  }
  editMemberOfBoard(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_members_of_board`, model)
      .pipe(catchError(this.handleError));
  }
  deleteMemberOfBoard(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_members_of_board`, model)
      .pipe(catchError(this.handleError));
  }
  getListMemberOfBoard(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_cab_members_of_board`, model)
      .pipe(catchError(this.handleError));
  }


  // Working Time
  addWorkingTime(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_working_time`, model)
      .pipe(catchError(this.handleError));
  }
  editWorkingTime(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_working_time`, model)
      .pipe(catchError(this.handleError));
  }
  deleteWorkingTime(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_working_time`, model)
      .pipe(catchError(this.handleError));
  }
  getListWorkingTime(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_cab_working_time`, model)
      .pipe(catchError(this.handleError));
  }

  // Working Days

  editWorkingDays(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_working_days`, model)
      .pipe(catchError(this.handleError));
  }

  // Branches
  editBranches(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/update_branches`, model)
      .pipe(catchError(this.handleError));
  }

  getListBranches(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_branches`, model)
      .pipe(catchError(this.handleError));
  }

  // Personnel information
  addPersonnelInformation(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_personnel_information`, model)
      .pipe(catchError(this.handleError));
  }
  editPersonnelInformation(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_personnel_information`, model)
      .pipe(catchError(this.handleError));
  }
  deletePersonnelInformation(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_personnel_information`, model)
      .pipe(catchError(this.handleError));
  }
  getListPersonnelInformation(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_cab_personnel_information`, model)
      .pipe(catchError(this.handleError));
  }

  // Existing Accreditation / Certification
  addExistingAccCer(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/add_existing_accreditation`, model)
      .pipe(catchError(this.handleError));
  }
  editExistingAccCer(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/edit_existing_accreditation`, model)
      .pipe(catchError(this.handleError));
  }
  deleteExistingAccCer(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/remove_existing_accreditation`, model)
      .pipe(catchError(this.handleError));
  }
  getListExistingAccCer(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/list_cab_existing_accreditation`, model)
      .pipe(catchError(this.handleError));
  }


  submitCAB_ProfileAgreement(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/cab_update_agreements`, model)
      .pipe(catchError(this.handleError));
  }

  changeCAB_webiteStatus(model) {
    return this.apiService
      .post(`${environment.apiUrl}/api/system/archiveCAB`, model)
      .pipe(catchError(this.handleError));
  }

  handleError(error) {
    return throwError(error);
  }
}
